module.exports = __webpack_public_path__ + "static/media/inversiones.682bbf9b.svg";